import React from "react";

const DropDownButton = ({
  modal,
  modalid,
  dropDownBtnName,
  dropDownBtnList,
  setScheduleType,
  iconClass
}) => {
  return (
    <>
      <button
        className="
    hf-vertical-button
    bg-berylline
    text-white
    border-0
    mr-3
  "
        type="button"
        id="dropdownMenuButton1"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <i className={iconClass} aria-hidden="true"></i>
        <p style={{ marginBottom: "0px" }}> {dropDownBtnName} <i className="fa fa-caret-down"></i></p>
      </button>
      <ul
        className="dropdown-menu hf-dropdown-menu"
        aria-labelledby="dropdownMenuButton1"
      >
        {dropDownBtnList?.map(({ option, key }) => {
          return (
            <li key={key}>
              <a
                className="dropdown-item"
                href="/#"
                id={`scheduleMeeting-${option}`}
                data-bs-toggle={(key === "zoom" || key === "person") && modal}
                data-bs-target={(key === "zoom" || key === "person") && modalid}
                onClick={() => setScheduleType(key)}
              >
                {option}
              </a>
            </li>
          );
        })}
      </ul>
    </>
  );
};

export default DropDownButton;
